import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VisibilityToggle = ({ entityType, entityId, currentVisibility, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const isVisible = currentVisibility === "all_players";

  const toggle = async (e) => {
    e.stopPropagation();
    setLoading(true);
    try {
      const res = await axios.put(
        `${API}/entities/${entityType}/${entityId}/quick-visibility`,
        {},
        { withCredentials: true }
      );
      onUpdate(res.data.visibility);
      toast.success(res.data.visibility === "all_players" ? "Visible to players" : "DM only");
    } catch {
      toast.error("Failed to toggle visibility");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      className={`h-8 w-8 ${isVisible ? 'text-green-400' : 'text-muted-foreground'}`}
      onClick={toggle}
      disabled={loading}
      title={isVisible ? "Visible to players — click to hide" : "DM only — click to show players"}
      data-testid={`visibility-toggle-${entityId}`}
    >
      {loading ? (
        <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      ) : isVisible ? (
        <Eye className="w-4 h-4" />
      ) : (
        <EyeOff className="w-4 h-4" />
      )}
    </Button>
  );
};

export default VisibilityToggle;
